<template>
  <div class="heatmap-wrapper">
    <div id="heatmap-container"></div>
  </div>
</template>

<script>
import h337 from "heatmap.js";
import ballPosition from "@/mixins/BallPosition";


export default {
  name: "Heatmap",
  props: {
    playerstats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      heatmapInstance: null, // Zum Speichern der Instanz
    };
  },
  mixins: [ballPosition],
  mounted() {
    this.processAndInitializeHeatmap(this.playerstats);
  },
  methods: {
    preparePlayerStats(playerstats) {
      return playerstats
          .filter((stat) => stat.position.x > 0 && stat.position.y > 0) // Filtere die Werte mit x > 0 und y > 0
          .map((stat) => {
            return {
              // x und y konvertieren und auf ganzzahlige Werte runden
              x: this.calculatePosition(Math.round(parseFloat(stat.position.x)), Math.round(parseFloat(stat.position.y))).x,
              y: this.calculatePosition(Math.round(parseFloat(stat.position.x)), Math.round(parseFloat(stat.position.y))).y,
              value: 1, // Fester Wert von 1
            };
          });
    },
    processAndInitializeHeatmap(playerstats) {
      const preparedStats = this.preparePlayerStats(playerstats);

      const container = document.getElementById("heatmap-container");
      const parent = container.parentElement.parentElement;

      const style = getComputedStyle(parent);
      const widthWithoutPadding = parent.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

      // Größe vor der Heatmap-Erstellung setzen
      container.style.width = `${widthWithoutPadding}px`;
      container.style.height = `${widthWithoutPadding}px`;

      // Vorhandene Heatmap-Instanz entfernen
      if (this.heatmapInstance) {
        container.innerHTML = ""; // Inhalte entfernen
        this.heatmapInstance = null; // Instanz löschen
      }

      this.heatmapInstance = h337.create({
        container: container,
        radius: 30,
        blur: 0.9,
      });
      const max = 2 //Math.max(...preparedStats.map(item => item.value));
      this.heatmapInstance.setData({ max, data: preparedStats });
    },
  },
  watch: {
    playerstats(newData) {
      this.processAndInitializeHeatmap(newData); // Aktualisiere Heatmap bei neuen Daten
    },
  },
};
</script>

<style scoped>
#heatmap-container {
  position: absolute!important;
  top: 0;
  height: 100%;
  aspect-ratio: 1 / 1;
}
</style>